module.exports = __webpack_public_path__ + "static/6-8b3c68409ac2cf37d50962f921c30395.jpeg";